__turbopack_context__.v({
  "author-info-icon": "ShowContributor-module__zDeHZG__author-info-icon",
  "before-text": "ShowContributor-module__zDeHZG__before-text",
  "book-card": "ShowContributor-module__zDeHZG__book-card",
  "book-details-authors": "ShowContributor-module__zDeHZG__book-details-authors",
  "contributor-name": "ShowContributor-module__zDeHZG__contributor-name",
  "view-less-icon": "ShowContributor-module__zDeHZG__view-less-icon",
  "view-more-button": "ShowContributor-module__zDeHZG__view-more-button",
  "view-more-icon": "ShowContributor-module__zDeHZG__view-more-icon",
});
